import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Navbar } from '../navbar/navbar';
import { FormsModule } from '@angular/forms';
import { ReturningPatient } from '../returning-patient/returning-patient';
import { Footer } from '../footer/footer';
import { PhoneNumber } from '../shared/phone-number/phone-number';
import { ClickableLink } from '../shared/clickable-link/clickable-link';
import { InPersonModal } from '../shared/in-person-modal/in-person-modal';
import { AuthContextService } from '../shared/auth-context.service';
import { getStateOptions } from '../shared/data/state-visit-config';
import { UserActivityService } from '../shared/services/user-activity.service';
import { shouldOpenReturningPatientModal, stripHopeHandoffParamsFromUrl } from '../shared/utils/hope-handoff';
@Component({
  selector: 'app-patient-type',
  imports: [CommonModule, FormsModule, Navbar, ReturningPatient, Footer, PhoneNumber, ClickableLink, InPersonModal],
  templateUrl: './patient-type.html',
  styleUrl: './patient-type.css'
})
export class PatientType implements OnInit {
  showReturningPatientModal: boolean = false;
  selectedType: 'new' | 'returning' | '' = '';
  errorMessage: string = '';
  // Reuse in-person modal UX from New Patient page
  showInPersonModal: boolean = false;
  inPerson: any = { firstName: '', lastName: '', phone: '', email: '', state: '', consent: false };
  stateOptions: any[] = [];
  constructor(
    private router: Router,
    private auth: AuthContextService,
    private userActivity: UserActivityService
  ) {}

  private pushDataLayerEvent(eventName: string) {
    const normalizedEventName = String(eventName || '').trim();
    if (!normalizedEventName) return;
    try {
      const dataLayer = (window as any).dataLayer = (window as any).dataLayer || [];
      dataLayer.push({ event: normalizedEventName });
    } catch {}
  }

  ngOnInit(): void {
    try { this.userActivity.trackPageView(); } catch {}

    // Load state options for the in-person modal
    try { this.stateOptions = getStateOptions(); } catch {}

    // Clear cached patient context whenever user lands on scheduler entry page
    try {
      this.auth.clearAll();
    } catch {}
    try {
      // Clean flow flags and transient data
      sessionStorage.removeItem('flow.bypass');
      sessionStorage.removeItem('flow.canSeeAvailableSlots');
      sessionStorage.removeItem('flow.canSeeDetailsMe');
      sessionStorage.removeItem('appointmentData');
      localStorage.removeItem('sheet.BasicCache');
      localStorage.removeItem('sheet.Date_received');
      localStorage.removeItem('sheet.Time_received');
      localStorage.removeItem("sheet.RowNumber");
      localStorage.removeItem('sheet.RowExisting');
      localStorage.removeItem('sheet.Row_number');
      localStorage.removeItem('RowNumber');
      localStorage.removeItem('Row_number');
    } catch {}
    // Optional: on reload, ensure caches are cleared as well
    try {
      const nav = (performance && (performance as any).getEntriesByType) ? (performance.getEntriesByType('navigation') as any) : [];
      const navType = (nav && nav[0] && nav[0].type) ? String(nav[0].type) : '';
      if (navType.toLowerCase() === 'reload') {
        this.auth.clearAll();
        try {
          localStorage.removeItem('sheet.Date_received');
          localStorage.removeItem('sheet.Time_received');
          localStorage.removeItem('sheet.RowNumber');
          localStorage.removeItem('sheet.RowExisting');
          localStorage.removeItem('sheet.Row_number');
          localStorage.removeItem('RowNumber');
          localStorage.removeItem('Row_number');
        } catch {}
      }
    } catch {}
    try { setTimeout(() => { try {
      localStorage.removeItem('sheet.RowNumber');
      localStorage.removeItem('sheet.RowExisting');
      localStorage.removeItem('sheet.Row_number');
      localStorage.removeItem('RowNumber');
      localStorage.removeItem('Row_number');
    } catch {} }, 0); } catch {}

    if (shouldOpenReturningPatientModal()) {
      this.selectedType = 'returning';
      this.showReturningPatientModal = true;
      this.errorMessage = '';
      stripHopeHandoffParamsFromUrl();
    }
  }
  onPatientTypeSelect(patientType: string) {
    this.selectedType = (patientType === 'new' || patientType === 'returning') ? (patientType as any) : '';
    this.errorMessage = '';
    if (this.selectedType === 'new') {
      this.pushDataLayerEvent('ols_new_patient_click');
      this.userActivity.trackClick('scheduler_new_patient_clicked', 'radio', 'New Patient');
    }
    if (this.selectedType === 'returning') {
      this.pushDataLayerEvent('ols_returning_patient_click');
      this.userActivity.trackClick('scheduler_returning_patient_clicked', 'radio', 'Returning Patient');
    }
  }
  onModalClosed() {
    this.showReturningPatientModal = false;
  }
  onPhoneNumberClicked() {
    this.userActivity.trackClick('scheduler_phone_number_clicked', 'link', 'Phone Number');
  }
  onClickHereClicked() {
    this.userActivity.trackClick('scheduler_click_here_clicked', 'link', 'Click here.');
    this.openInPersonModal();
  }
  openInPersonModal() { this.showInPersonModal = true; }
  closeInPersonModal() { this.showInPersonModal = false; }
  formatInPersonPhone(event: Event) {
    const input = event.target as HTMLInputElement;
    const digits = (input.value || '').replace(/\D/g, '').slice(0, 10);
    const formatted = digits.length <= 3 ? digits : (digits.length <= 6 ? `${digits.slice(0,3)}-${digits.slice(3)}` : `${digits.slice(0,3)}-${digits.slice(3,6)}-${digits.slice(6)}`);
    input.value = formatted;
    this.inPerson.phone = formatted;
  }
  submitInPerson() {
0    // simple front-end validation parity
    if (!this.inPerson.firstName || !this.inPerson.lastName || !/^\d{3}-\d{3}-\d{4}$/.test(this.inPerson.phone) || !this.inPerson.email || !this.inPerson.state || !this.inPerson.consent) {
      return;
    }
    this.closeInPersonModal();
  }
  onNext() {
    this.pushDataLayerEvent('ols_1st_next_button_click');
    this.userActivity.trackClick('scheduler_next_button_clicked', 'button', 'Next');
    if (!this.selectedType) {
      this.errorMessage = 'Please select an option first';
      return;
    }
    if (this.selectedType === 'new') {
      this.router.navigate(['/newpatient']);
      return;
    }
    if (this.selectedType === 'returning') {
      this.showReturningPatientModal = true;
      return;
    }
  }
}
